const e = ()=>typeof window > "u", i = ()=>!e();
export { i as isClientSide, e as isServerSide };
